export class AuthenticationType {
    id: number;
    name: string;
}
